export const isMcpAdminEnabled = (): boolean =>
  String(process.env.REACT_APP_ENABLE_MCP_ADMIN || '').trim().toLowerCase() === 'true';
